/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-09 20:47:13
 * @LastEditors: linxi
 * @LastEditTime: 2021-04-28 19:59:51
 */
import { CaretDownFilled } from "@ant-design/icons";
import { DatePicker, Select } from "antd";
import moment, { Moment } from "moment";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../theme/theme";

export enum DateRangeType {
  Last7Days,
  Last30Days,
  LastYear,
  Range,
}

const DateRangeTypes = [
  DateRangeType.Last7Days,
  DateRangeType.Last30Days,
  DateRangeType.LastYear,
  DateRangeType.Range,
];

const DateRangeTypeNames = ["近7天", "近30天", "近一年", "自定义时间"];

type DateSelectValue = [Moment | null, Moment | null];
interface DateSelectProps {
  value?: DateSelectValue;
  onChange?: (value?: DateSelectValue) => void;
  allowClear?: boolean;
  placeholder?: string;
  style?: React.CSSProperties;
}

export function getDateRange(type?: DateRangeType): DateSelectValue {
  let head = null;
  const tail = moment().endOf("days");
  switch (type) {
    case DateRangeType.Last7Days:
      head = moment().subtract(6, "days").startOf("days");
      break;
    case DateRangeType.Last30Days:
      head = moment().subtract(29, "days").startOf("days");
      break;
    case DateRangeType.LastYear:
      head = moment().subtract(12, "months").startOf("days");
      break;
  }
  return [head, head ? tail : null];
}

export const DateRangeFieldName = "_dateRange";

export const DateSelect = ({
  value,
  onChange,
  allowClear = true,
  placeholder,
  style,
}: DateSelectProps): ReactElement => {
  const theme = useContext(ThemeContext);

  const [dateType, setDateType] = useState<DateRangeType | undefined>();

  useEffect(() => {
    if (value) {
      const head = value?.[0];
      const tail = value?.[1];
      if (head && tail) {
        const days = moment.duration(tail.diff(head)).asDays();
        if (
          head.format("YYYY/MM/DD HH:mm:ss").endsWith("00:00:00") &&
          tail.format("YYYY/MM/DD HH:mm:ss").endsWith("23:59:59")
        ) {
          switch (Math.round(days)) {
            case 7:
              setDateType(DateRangeType.Last7Days);
              break;
            case 30:
              setDateType(DateRangeType.Last30Days);
              break;
            default:
              setDateType(DateRangeType.LastYear);
          }
        } else {
          setDateType(DateRangeType.Range);
        }
      }
    }
  }, [value]);

  return (
    <>
      <Select
        allowClear={allowClear}
        placeholder={placeholder}
        style={style}
        value={dateType}
        suffixIcon={<CaretDownFilled style={{ color: theme.tc3 }} />}
        onChange={(v?: DateRangeType) => {
          setDateType(v);
          if (v !== DateRangeType.Range) {
            onChange && onChange(getDateRange(v));
          }
        }}
      >
        {DateRangeTypes.map((t) => (
          <Select.Option key={t} value={t}>
            {DateRangeTypeNames[t]}
          </Select.Option>
        ))}
      </Select>
      {dateType === DateRangeType.Range && (
        <DatePicker.RangePicker
          style={{ marginLeft: "8px" }}
          value={value}
          onChange={(range) => {
            const head = range?.[0]?.startOf("day")?.add(1, "seconds") ?? null;
            const tail = range?.[1]?.endOf("day")?.subtract(1, "seconds") ?? null;
            onChange && onChange([head, tail]);
          }}
        />
      )}
    </>
  );
};
